export const configKeys = {
  DISPLAY_SIZES: "DISPLAY_SIZES",
  DISPLAY_MIME_TYPES: "DISPLAY_MIME_TYPES",
  VIDEO_SIZES: "VIDEO_SIZES",
  VIDEO_MIME_TYPES: "VIDEO_MIME_TYPES",
  Media_Type: "Media_Type",
  platform: "platform",
  ONSCREEN_POSITION: "ONSCREEN_POSITION",
  Pacing_Type: "Pacing_Type",
  Duration_Type: "Duration_Type",
  Bidding_Strategy: "Bidding_Strategy",
  Bidding_Strategy_Search: "Bidding_Strategy_Search",
  Bidding_Strategy_Display: "Bidding_Strategy_Display",
  Bidding_Strategy_Video: "Bidding_Strategy_Video",
  Device_Type: "Device_Type",
  Language: "Language",
  Tracker_Event_Image: "Tracker_Event_Image",
  Tracker_Event_Video: "Tracker_Event_Video",
  Tracker_Type_Image: "Tracker_Type_Image",
  Tracker_Type_Video: "Tracker_Type_Video",
  Gender_Type: "Gender_Type",
  Age_Type: "Age_Type",
  MaximiseClick: "Maximize click",
  Business_Type: "Business_Type",
  Objective: "Objective",
  OnScreen_Position_VIADS_Screen_Position_Display:"OnScreen_Position_VIADS_Screen_Position_Display",
  OnScreen_Position_VIADS_Screen_Position_Video:"OnScreen_Position_VIADS_Screen_Position_Video",
  Publisher_Platforms:"Publisher_Platforms"
};
